import { Button, Card, Col, Flex, Form, Input, Modal, Row, Skeleton, Space } from "antd";
import { useForm } from "antd/es/form/Form";
import StatusTag from "components/elements/TagCustom/StatusTag";
import FormAntd from "components/form/FormProvide/FormAntd";
import dayjs from 'dayjs';
import { useTranslation } from "react-i18next";
import { ReactComponent as FilterIcon } from "../../../assets/icon/filterIcon.svg";
import { ReactComponent as EditIcon } from "../../../assets/images/edit.svg";
import { get2DecimalPointsWithCommas } from "components/numberFormatDigits";
// import { DownloadOutlined, FileTextOutlined, MailOutlined } from "@ant-design/icons";
import { ReactComponent as DownloadIcon } from "../../../assets/icon/downloadIcon.svg";
import DocumentSendToBankModal from "./DocumentSendToBankModal";

const ClosePage = ({
    PAYMENT_TAB = [],
    getTable = () => { },
    getVisibleIcon = () => { },
    searchTxt = "",
    onChange = () => { },
    onSearch = () => { },
    onClearSearchTxt = () => { },
    payrollPeriod = {},
    isLoading = false,
    isTextFileLoading = false,
    onEditPayroll = () => { },
    onPageTypeChange = () => { },
    updateHeaderStatusToPayment = () => { },
    updateHeaderStatusToApproval = () => { },
    totalEmployeeTab = {},
    returnPayment = () => { },
    getReport = () => { },
    getReportBBL = () => { },
    company = {},
    exportTextFileBank = () => { },
    confirmModalFn = () => { },
    isModalDocumentOpen,
    onDocumentModalOpen = () => { },
    onDocumentModalClose = () => { }
}) => {
    const { t, i18n } = useTranslation()
    const form = useForm(null);
    const isSpecialPeriod = payrollPeriod?.specialPeriod == "Y"

    return (
        <>
            <DocumentSendToBankModal
                isModalOpen={isModalDocumentOpen}
                company={company}
                exportDocForBank={getReport}
                exportDocForBankBLL={getReportBBL}
                exportTextFileBank={exportTextFileBank}
                onDocumentModalClose={onDocumentModalClose}
                isLoading={isLoading}
                isTextFileLoading={isTextFileLoading}
            />
            <Card style={{ backgroundColor: "#FCFCFC", borderRadius: "10px", border: "1px solid #D9D9D9", "height": "30vh", "width": "40vw" }}>
                {isLoading ? (
                    <Skeleton active={isLoading} />
                ) :
                    <Space direction='vertical' styles={{ "height": "20vh", "width": "30vw" }}>
                        <Row justify="space-between">
                            <span style={{ fontSize: "18px", color: "#42526D", fontWeight: "bold" }}>
                                {t("payment_period.label.period")} {dayjs(String(payrollPeriod?.month, "MM")).format('MMMM')} {isSpecialPeriod ? t("payment_period.label.special_period") : t("payment_period.label.period_no")} {payrollPeriod?.periodNo}
                            </span>
                            <StatusTag
                                value={payrollPeriod?.statusFlag}
                                text={(i18n.language === 'en' ? payrollPeriod?.statusNameEn : payrollPeriod?.statusName)}
                            />
                        </Row>
                        <Row style={{ gap: "32px" }}>
                            <Flex vertical>
                                <span style={{ color: "#42526D" }}>{t("payroll.employment_type_setup.header")}</span>
                                {payrollPeriod?.employmentType?.map((o) => (
                                    <span key={o?.id} style={{ fontSize: "18px", color: "#42526D", fontWeight: "bold" }}>
                                        {i18n.language === 'en' ? o?.employmentTypeNameEn : o?.employmentTypeName}
                                    </span>
                                ))}
                            </Flex>
                            <Flex vertical>
                                <span style={{ color: "#42526D" }}>{t("payroll.payroll_period")}</span>
                                <span style={{ fontSize: "18px", color: "#42526D", fontWeight: "bold" }}>
                                    {i18n.language === "en"
                                        ? (dayjs(payrollPeriod?.startPeriod).format("DD/MM/YYYY") + " - " + dayjs(payrollPeriod?.endPeriod).format("DD/MM/YYYY"))
                                        : (dayjs(payrollPeriod?.startPeriod).format("DD/MM/BBBB") + " - " + dayjs(payrollPeriod?.endPeriod).format("DD/MM/BBBB"))}
                                </span>
                            </Flex>

                            <Flex vertical>
                                <span style={{ color: "#42526D" }}>{t("payment_period.label.payment_date")}</span>

                                <Flex gap={8}>
                                    <span style={{ fontSize: "18px", color: "#42526D", fontWeight: "bold" }}>
                                        {i18n.language === "en"
                                            ? dayjs(payrollPeriod?.paymentDate).format("DD/MM/YYYY")
                                            : dayjs(payrollPeriod?.paymentDate).format("DD/MM/BBBB")}
                                    </span>
                                    {/* {payrollPeriod?.step === 0 && (
                                        <EditIcon style={{ fontSize: "16px", padding: 0, alignSelf: "center", cursor: "pointer" }} onClick={() => onEditPayroll()} />
                                    )} */}
                                </Flex>

                            </Flex>
                        </Row>
                        <Row>
                            <Col span={24}>
                                <Flex justify="space-between">
                                    <Flex vertical>
                                        <span style={{ color: "#42526D" }}>{t('payment.label.numberOfEmployee')}</span>
                                        <span style={{ fontSize: "18px", color: "#42526D", fontWeight: "bold" }}>
                                            {payrollPeriod?.numberOfEmployee ?? 0 + " " + t("expense.expense-detail.person")}
                                        </span>
                                    </Flex>
                                    <Flex vertical>
                                        <span style={{ color: "#42526D" }}>{t('payment.label.total')}</span>
                                        <span style={{ fontSize: "18px", color: "#42526D", fontWeight: "bold" }}>
                                            {get2DecimalPointsWithCommas(payrollPeriod?.netIncome) + " " + t('unit.baht')}
                                        </span>
                                    </Flex>

                                </Flex>

                            </Col>
                        </Row>
                    </Space>
                }
            </Card>

            <Row style={{ marginTop: '10px' }}>
                <Col span={24}>
                    <Flex justify="space-between">
                        <Flex justify="start">
                            <FormAntd
                                initialValues={{ searchTxt }}
                                onFinish={onSearch}

                            >
                                <Form.Item name="searchTxt" style={{ "width": "40vw" }} >
                                    <Flex gap={10} >
                                        <Input
                                            name="searchTxt"
                                            placeholder={i18n.language === 'en' ? "employee no / name / nameEn / surname / surnameEn" : "รหัสพนักงาน / ชื่อ / นามสกุล / ชื่อภาษาอังกฤษ / นามสกุลภาษาอังกฤษ"}
                                            style={{ "height": "5vh", width: "30vw" }}
                                        />
                                        <Button
                                            // loading={isLoading}
                                            type="default"
                                            onClick={onClearSearchTxt}
                                            style={{ borderRadius: 8, "height": "5vh", "width": "6vw" }}
                                        >
                                            {t("common.clear").toUpperCase()}
                                        </Button>
                                        <Button
                                            title="1"
                                            // loading={isLoading}
                                            type="primary"
                                            htmlType="submit"
                                            style={{ height: "5vh", width: "6vw", borderRadius: 8, backgroundColor: "var(--button-color)", }}
                                        >
                                            {/* <Flex justify="space-between"> */}
                                            {t("creatTamplete.Search").toUpperCase()}
                                            {/* </Flex> */}
                                        </Button>
                                    </Flex>
                                </Form.Item>
                            </FormAntd>
                        </Flex>

                        <Flex justify="end" gap={10}>
                            {payrollPeriod?.step >= 3 ?
                                <Button
                                    type="default"
                                    style={{ padding: "8px 16px", height: 44, borderRadius: 8 }}
                                    onClick={onDocumentModalOpen}
                                // onClick={()=>confirmModalFn(getReport)}
                                // onClick={() => {
                                //     Modal.confirm({
                                //         title: t("dialog.confirmation.header"),
                                //         content: i18n.language === 'en' ? "Do you want to download the salary report ?" : "ต้องการดาวน์โหลดรายงานเงินเดือนหรือไม่",
                                //         onOk() {
                                //             getReport();
                                //         },
                                //         okText: t("common.confirm"),
                                //         cancelText: t("common.cancel"),
                                //     });
                                // }}
                                >
                                    <Flex align="center" justify="center" gap={8}>
                                        <DownloadIcon />
                                        <span style={{ color: "#667085" }}>{t('payment.label.doc_bank')}</span>
                                    </Flex>
                                </Button> : null}
                            {/* <Button
                                type="default"
                                style={{ padding: "8px 16px", height: 44, borderRadius: 8 }}
                            >
                                <Flex align="center" justify="center" gap={8}>
                                    <FilterIcon />
                                    <span style={{ color: "#667085" }}>{t('common.filter')}</span>
                                </Flex>
                            </Button> */}
                            {getVisibleIcon()}
                        </Flex>
                    </Flex>

                    <Row>
                        <Col span={24}>{getTable()}</Col>
                    </Row>
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    {payrollPeriod?.step === 3 ? <Flex gap="5px" justify="end">
                        <Button
                            style={{ borderRadius: "8px", height: "40px", backgroundColor: totalEmployeeTab?.countIncomplete > 0 ? "" : "var(--button-color)" }}
                            type="primary"
                            htmlType="submit"
                            // disabled={payrollPeriod?.step !== 1}
                            onClick={() => {
                                Modal.confirm({
                                    title: t("dialog.confirmation.header"),
                                    content: (
                                        <>
                                            <p>
                                                {t("payment.label.send-request-for-back-approve")}

                                            </p>
                                        </>
                                    ),
                                    onOk() {
                                        updateHeaderStatusToApproval()

                                    },
                                    okText: t("common.confirm"),
                                    cancelText: t("common.cancel"),
                                });
                            }}
                        >
                            {t("payment.label.send-request-for-back-approve")}
                        </Button>
                        <Button
                            style={{ borderRadius: "8px", height: "40px", backgroundColor: totalEmployeeTab?.countIncomplete > 0 ? "" : "var(--button-color)" }}
                            type="primary"
                            htmlType="submit"
                            // disabled={payrollPeriod?.step !== 3}
                            onClick={() => {
                                Modal.confirm({
                                    title: t("dialog.confirmation.header"),
                                    content: (
                                        <>
                                            <p>
                                                {/* {t("payment.label.step.close")} */}
                                                {i18n.language === 'en' ? "Confirm close period ?" : "ยืนยันการปิดงวดเงินเดือนหรือไม่ ?"}
                                            </p>
                                        </>
                                    ),
                                    onOk() {
                                        updateHeaderStatusToPayment()
                                    },
                                    okText: t("common.confirm"),
                                    cancelText: t("common.cancel"),
                                });
                            }}
                        >
                            {t("payment.label.step.close")}
                        </Button>
                    </Flex> : null}

                </Col>
            </Row>
        </>
    )
}

export default ClosePage